var _GroupSeparator;
import * as React from 'react';
import { LinksList, GroupSeparator } from '../Sidebar.styles';
import SidebarMenuItem from '../SidebarMenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderLinks(links, {
  open,
  pathname,
  onItemClick,
  enableIosTap
}) {
  return Object.keys(links.reduce((acc, link) => {
    const groupKey = link.group || 'default';
    const groupedLinks = {
      ...acc
    };
    if (!groupedLinks[groupKey]) {
      groupedLinks[groupKey] = [];
    }
    groupedLinks[groupKey].push(link);
    return groupedLinks;
  }, {})).map((groupKey, index) => /*#__PURE__*/_jsxs(React.Fragment, {
    children: [index > 0 && (_GroupSeparator || (_GroupSeparator = /*#__PURE__*/_jsx(GroupSeparator, {}))), links.filter(link => (link.group || 'default') === groupKey).map(link => /*#__PURE__*/_jsx(React.Fragment, {
      children: /*#__PURE__*/_jsx(SidebarMenuItem, {
        link: link,
        open: open,
        pathname: pathname,
        onClick: onItemClick,
        enableIosTap: enableIosTap
      })
    }, `${groupKey}-${link.label}`))]
  }, groupKey || `default-group-${index}`));
}
function SidebarLinks({
  links,
  open,
  pathname,
  onItemClick,
  enableIosTap,
  hasTenants,
  mobile,
  customWrapper: Wrapper = LinksList
}) {
  return /*#__PURE__*/_jsx(Wrapper, {
    $hasTenants: hasTenants,
    $mobile: mobile,
    className: "ovpn-sidebar-links",
    children: renderLinks(links, {
      open,
      pathname,
      onItemClick,
      enableIosTap
    })
  });
}
export default SidebarLinks;